import { writable } from "svelte/store";
import { loadLSStateKey, setLSStateKey } from "./localStorage";
import constants from "@/constants";

const dataKey = "userProfiles";
const initialState = {
  list: {},
};
const { NO_MORE_POSTS_OFFSET } = constants;
const { subscribe, update, set } = writable(initialState);

const savedData = loadLSStateKey("state", dataKey);
if (savedData && typeof savedData === "object") {
  set(savedData);
}

subscribe((current) => {
  setLSStateKey("state", dataKey, current);
});
/**
 *
 * @param {String} handle
 * @param {Object} d
 * @returns
 */
const updateState = (handle, d) =>
  update(() => {
    const newList = { [handle]: d };
    return {
      list: newList,
    };
  });
/**
 *
 * @param {String} handle
 * @param {Array} d
 * @param {String} lp
 * @param {String} reducerAction
 * @returns {Object}
 */
const updateVideos = (handle, d, lp, reducerAction) =>
  update((oldState) => {
    const newList = { ...oldState.list };
    if (newList[handle] && Array.isArray(d)) {
      let newVideos = newList[handle].videos;
      if (reducerAction === "concat" && Array.isArray(newVideos)) {
        newVideos = [...newVideos, ...d];
      } else {
        newVideos = d;
      }
      newList[handle] = {
        ...newList[handle],
        videos: newVideos,
        lp: d.length > 0 ? lp : NO_MORE_POSTS_OFFSET,
      };
    }
    return {
      list: newList,
    };
  });
const togglePostLike = (action, handle, index) => {
  update((oldState) => {
    const newList = { ...oldState.list };
    if (newList[handle]) {
      const videosList = newList[handle].videos;
      videosList[index] = {
        ...videosList[index],
        lc: parseInt(videosList[index].lc) + (action ? 1 : -1),
        pl: action,
      };

      newList[handle] = {
        ...newList[handle],
        videos: videosList,
      };
    }
    return {
      list: newList,
    };
  });
};

export default {
  subscribe,
  updateState,
  updateVideos,
  togglePostLike,
};
